import getAudioContext from './getAudioContext';

export default function canPlayAudio() {
  const state = getAudioContext().state;
  console.log('canPlayAudio :: state', state);
  return state !== 'closed' && state !==  'suspended';
}